/**
 * Kozler FAQ — hero jump navigation builder.
 * Each category lives in its own section so the 50-block limit applies per
 * category rather than per page, which means the hero can no longer build its
 * nav in Liquid. This collects [data-koz-faq-category] sections in DOM order
 * and renders the links into [data-koz-faq-nav].
 */
(function () {
  'use strict';

  if (window.KozFaq && window.KozFaq.__bound) return;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function collectCategories() {
    var categories = [];

    document.querySelectorAll('[data-koz-faq-category]').forEach(function (section) {
      var anchor = (section.getAttribute('data-koz-faq-anchor') || '').trim();
      var label = (section.getAttribute('data-koz-faq-label') || '').trim();
      var number = (section.getAttribute('data-koz-faq-number') || '').trim();

      if (!anchor || (!label && !number)) return;

      categories.push({ anchor: anchor, label: label, number: number });
    });

    return categories;
  }

  function scrollToAnchor(anchor) {
    var target = document.getElementById(anchor);
    if (!target) return false;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + anchor);
    }

    return true;
  }

  function onLinkClick(event) {
    var anchor = (event.currentTarget.getAttribute('data-koz-faq-target') || '').trim();
    if (scrollToAnchor(anchor)) event.preventDefault();
  }

  function renderNav(nav) {
    var list = nav.querySelector('[data-koz-faq-nav-links]');
    if (!list) return;

    var categories = collectCategories();

    if (!categories.length) {
      list.innerHTML = '';
      nav.hidden = true;
      return;
    }

    list.innerHTML = categories
      .map(function (category) {
        var text = [category.number, category.label].filter(Boolean).join(' ');
        return (
          '<a class="koz-faq-hero__jump-link" data-koz-faq-link data-koz-faq-target="' +
          escapeHtml(category.anchor) +
          '" href="#' +
          escapeHtml(category.anchor) +
          '">' +
          escapeHtml(text) +
          '</a>'
        );
      })
      .join('');

    list.querySelectorAll('[data-koz-faq-link]').forEach(function (link) {
      link.addEventListener('click', onLinkClick);
    });

    nav.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-koz-faq-nav]').forEach(renderNav);
  }

  // Theme editor events fire before the DOM settles, so rebuild on the next frame.
  function scheduleInit() {
    window.requestAnimationFrame(init);
  }

  window.KozFaq = {
    __bound: true,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('shopify:section:unload', scheduleInit);
  document.addEventListener('shopify:section:reorder', scheduleInit);
})();
